import React, { useState, useEffect } from 'react';

const Error404 = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const eyeX = (position.x - window.innerWidth / 2) / 50;
  const eyeY = (position.y - window.innerHeight / 2) / 50;

  const styles = `
    .error-404-container {
      min-height: 100vh;
      background: linear-gradient(135deg, #581c87 0%, #1e3a8a 50%, #312e81 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      overflow: hidden;
      position: relative;
    }

    .particles-container {
      position: absolute;
      inset: 0;
      overflow: hidden;
      pointer-events: none;
    }

    .particle {
      position: absolute;
      width: 8px;
      height: 8px;
      background-color: white;
      border-radius: 50%;
      opacity: 0.2;
      animation: pulse 2s ease-in-out infinite;
    }

    @keyframes pulse {
      0%, 100% {
        opacity: 0.2;
      }
      50% {
        opacity: 0.5;
      }
    }

    .error-content {
      position: relative;
      z-index: 10;
    }

    .error-title {
      font-size: clamp(4rem, 15vw, 10rem);
      letter-spacing: 0.1em;
    }

    .eyes-container {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
    }

    .eye {
      width: 24px;
      height: 24px;
      background-color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .pupil {
      width: 12px;
      height: 12px;
      background-color: #1f2937;
      border-radius: 50%;
      transition: transform 0.1s ease-out;
    }

    .btn-hover-primary:hover {
      background-color: #dbeafe !important;
      transform: scale(1.05);
      transition: all 0.2s ease;
    }

    .btn-hover-fill:hover {
      background-color: white !important;
      color: #581c87 !important;
      transform: scale(1.05);
      transition: all 0.2s ease;
    }

    .text-white-50 {
      color: rgba(255, 255, 255, 0.6);
    }

    @media (max-width: 768px) {
      .error-title {
        font-size: 5rem;
      }
      
      .eye {
        width: 18px;
        height: 18px;
      }
      
      .pupil {
        width: 9px;
        height: 9px;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="error-404-container">
        {/* Floating particles */}
        <div className="particles-container">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="particle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${2 + Math.random() * 3}s`
              }}
            />
          ))}
        </div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center error-content">
              {/* Animated 404 with eyes */}
              <div className="position-relative mb-5">
                <h1 className="display-1 fw-bold text-white error-title">
                  4
                  <span className="d-inline-block position-relative mx-3 mx-md-4">
                    <span className="text-white">0</span>
                    {/* Eyes inside the 0 */}
                    <div className="eyes-container">
                      <div className="eye">
                        <div 
                          className="pupil"
                          style={{ transform: `translate(${eyeX}px, ${eyeY}px)` }}
                        />
                      </div>
                      <div className="eye">
                        <div 
                          className="pupil"
                          style={{ transform: `translate(${eyeX}px, ${eyeY}px)` }}
                        />
                      </div>
                    </div>
                  </span>
                  4
                </h1>
              </div>

              {/* Error message */}
              <h2 className="display-5 fw-bold text-white mb-4">
                Oops! Page Not Found
              </h2>
              <p className="lead text-white-50 mb-5 mx-auto" style={{ maxWidth: '500px' }}>
                The page you're looking for seems to have wandered off into the digital void.
              </p>

              {/* Action buttons */}
              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <button 
                  onClick={() => window.history.back()}
                  className="btn btn-light btn-lg px-5 py-3 fw-semibold shadow btn-hover-primary"
                >
                  Go Back
                </button>
                <button 
                  onClick={() => window.location.href = '/'}
                  className="btn btn-outline-light btn-lg px-5 py-3 fw-semibold btn-hover-fill"
                >
                  Go Home
                </button>
              </div>

              {/* Fun suggestion */}
              <p className="text-white-50 mt-5 small">
                Lost? Try moving your mouse around! 👀
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error404;